import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  AlertScreen: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    width: '100%',
    zIndex: 1,
    '&__text': {
      backgroundColor: theme.palette.backgroundColor,
      border: `2px solid ${theme.palette.primary.main}`,
      borderRadius: 12,
      color: theme.palette.primary.main,
      margin: 10,
      maxWidth: 450,
      padding: 10,
      textAlign: 'center',
      whiteSpace: 'pre-line',
      width: '100%',
    },
  },
}));

export { useStyles };
